export default __webpack_public_path__ + "static/media/afterHero2.a961023d.png";